import { render, staticRenderFns } from "./PersonalIdeas.vue?vue&type=template&id=8cdb16b6&"
import script from "./PersonalIdeas.vue?vue&type=script&lang=js&"
export * from "./PersonalIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports